module.exports = (__webpack_require__(0))(217);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/ItemListWidget.js from dll-reference girder_plugin_large_image
// module id = 79
// module chunks = 0